/**
 *
 * ReportExport
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect/lib/index"
import { compose } from "redux"
import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"

import {
  makeSelectLoadingMeditionsReportExport,
  makeSelectReportExport,
  makeSelectDivisionAmbassador,
  makeSelectLoadingDivisionsReportExport,
  makeSelectConfiguration,
} from "./selectors"
import {
  exportReportWatcher,
  getMeditionsReportExportWatcher,
  getDivisionsAmbassadorReportExportWatcher,
} from "./actions"
import reducer from "./reducer"
import Layout from "components/Layout"
import { Button, Radio, Tooltip, Select, Spin } from "antd"
import saga from "./saga"
import imageMail from "../../../images/imageEmail.svg"
import ModalCustom from "../../../components/ModalCustom"
import PreviewImage from "./Components/PreviewImage"
import VariablesExport from "./Components/VariablesExport"
import { ROLE_LEADER } from "utils/constants"
import { isEqual } from "lodash"
import { LeftOutlined } from "@ant-design/icons"
import "./index.less"
import { woopraTrack } from "../../../utils/woopra/woopraTracker"
import { LOCAL_ACTIVE_ROL, LOCAL_AMBASSADOR_ID, isAmbassadorActive } from "../../../utils/storage"
import { validate } from "../../../utils/functions"
import { loadTexts, sanitize } from "../../../utils/i18n"
import { buttonAction_btns } from "../../../components/Snowplow/config2"

const { Option } = Select
let medition_segment
export class ReportExport extends React.Component {
  intlExportable = loadTexts("reports_exportables")
  constructor(props) {
    super(props)
    // this.goBack = this.goBack.bind(this); // i think you are missing this
    this.state = {
      isAmbassador: false,
      messageHeader: "Reportes",
      exportVariable: [],
      exportVariableSegment: [],
      exportScopeSelect: "all",
      exportType: "xlsx",
      exportScope: "all",
      exportTemplate: "table",
      exportMedition: null,
      exportMeditionLeader: false,
      exportDownload: ["all"],
      medition: "",
      showSegmentVariables: true,
      currentMedition: -1,
      modalExportSuccess: false,
      defaultOptions: [
        {
          id: 1,
          type: 1,
          values: [
            "byDestinatario1",
            "byDivision1",
            "byDimension1",

            "qualitative1",
           /*  "byEnps1", */
            "division1",
            "bySegment1",
            "team1",
            "byTeam1",
            "byMultipleOption1",
          ],
        },
        {
          id: 2,
          type: 2,
          values: [
            "byDestinatario2",
            "byDivision2",
            "byDimension2",
            "qualitative2",
            /* "byEnps2", */
            "bySegment2",
            "byTeam2",
            "division2",
            "byMultipleOption2",
          ],
        },
        {
          id: 3,
          type: 3,
          values: [
            "byDivision3",
            "byDimension3",
          /*   "byEnps3", */
            "qualitative3",
            "byMultipleOption3",
          ],
        },
        {
          id: 4,
          type: 4,
          values: [
            "byDivision4",
            "byDimension4",
           /*  "byEnps4", */
            "qualitative4",
            "byMultipleOption4",
          ],
        },
        {
          id: 5,
          type: 5,
          values: [
            "tmpIntroduction5",
            "tmpSummary5",
            "tmpMeasureModel5",
            "tmpMeasureMethodology5",
            "tmpAllResult5",
           /*  "byEnps5", */
            "byDimension5",
            "division5",
            "bySegment5",
            "conclusions5",
            "byMultipleOption5",
          ],
        },
        {
          id: 6,
          type: 6,
          values: [
            "tmpIntroduction6",
            "tmpSummary6",
            "tmpMeasureModel6",
            "tmpMeasureMethodology6",
            "tmpAllResult6",
          /*   "byEnps6", */
            "byDimension6",
            "bySegment6",
            "conclusions6",
            "byMultipleOption6",
          ],
        },
      ],
      defaultLeaderShipOptions: [
        {
          id: 1,
          type: 1,
          values: [
            "byDestinatario1",
            "byDimension1",

            "qualitative1",
          /*   "byEnps1", */
            "bySegment1",
            "byTeam1",
            "team1",
            "byMultipleOption1",
          ],
        },
        {
          id: 2,
          type: 2,
          values: [
            "byDestinatario2",
            "byTeam2",
            "byDimension2",
            "qualitative2",
      /*       "byEnps2", */
            "bySegment2",
            "byMultipleOption2",
          ],
        },
        {
          id: 3,
          type: 3,
          values: [
            "byTeam3",
            "byDimension3",
            "qualitative3",
            "byMultipleOption3",
          ],
        },
        {
          id: 4,
          type: 4,
          values: ["byDimension4", "qualitative4", "byMultipleOption4"],
        },
      ],
      defaultSegmentOptions: [
        "byAge",
        "byCompanyTime",
        "byGender",
        "byCategory",
        "byLocation",
      ],
      typeReport: 1,
    }
  }

  UNSAFE_componentWillMount() {
    this.props.getMeditionsExport({ go: true })
  }

  loadDivisions = (id_measure) => {
    let { isAmbassador } = this.state
    let { loading_meditions_export } = this.props
    if (isAmbassador && !loading_meditions_export) {
      this.props.getDivisionsAmbasador({
        id_ambassador_profile_filter: LOCAL_AMBASSADOR_ID(),
        searchByIdMeasure: id_measure,
      })
    }
  }

  goBack = () => {
    this.props.history.goBack()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let meditions = nextProps.meditions_export
    if (meditions.length > 0) {
      let findMedition = meditions.find(
        (m) => m.id_measure == nextProps.match.params.id
      )
      if (validate.exist(findMedition) && Number(nextProps.match.params.id)) {
        let messageHeader = nextProps.match.params.nameView
        let scopeSelect = "all"
        let segment = undefined
        if (findMedition.survey_segment) {
          if (findMedition.segments.length === 1) {
            scopeSelect = "segmento"
            segment = findMedition.segments[0].id_segment
          }
        }

        this.setState({
          currentMedition: findMedition,
          exportMedition: findMedition,
          hasEnps: findMedition.has_enps,
          exportMeditionLeader: findMedition.id_survey_type === 2,
          exportScopeSelect: scopeSelect,
          exportSegment: segment,
          messageHeader:
            messageHeader === "division"
              ? "Ranking de divisiones"
              : messageHeader === "analysis-comparative"
              ? "Análisis comparativo"
              : messageHeader === "question"
              ? "Respuestas cualitativas"
              : messageHeader === "dimensions"
              ? "Resultado por dimensión"
              : findMedition.name,
        })
        if (validRole({ role: [5, 6] })) {
          this.setState({ isAmbassador: true, exportScopeSelect: "division" })
          this.setValuesDefaultIfUserLeader()
        }
      } else {
        let findMedition = meditions[0]
        let scopeSelect = "all"
        let segment = undefined
        if (findMedition.survey_segment) {
          if (findMedition.segments.length === 1) {
            scopeSelect = "segmento"
            segment = findMedition.segments[0].id_segment
          }
        }

        this.setState({
          currentMedition: meditions[0],
          hasEnps: findMedition.has_enps,
          exportMeditionLeader:
            meditions[0] && meditions[0].id_survey_type === 2,
          exportMedition: meditions[0],
          exportScopeSelect: scopeSelect,
          exportSegment: segment,
        })
        if (validRole({ role: [5, 6] })) {
          this.setState({ isAmbassador: true, exportScopeSelect: "division" })
          this.setValuesDefaultIfUserLeader()
        }
      }
    }
  }

  setValuesDefaultIfUserLeader = () => {
    let defaultLeaderShipOptions = this.state.defaultLeaderShipOptions
    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()
    if (isUserLeader) {
      defaultLeaderShipOptions[1].values.push("team2")
      defaultLeaderShipOptions[3].values.push("byTeam4")
      this.setState({
        defaultLeaderShipOptions,
      })
    }
  }

  componentDidUpdate = (prevProps, nextState) => {
    let { currentMedition } = this.state
    if (!isEqual(prevProps.meditions_export, this.props.meditions_export)) {
      if (validRole({ role: [5] }) && currentMedition) {
        this.props.getDivisionsAmbasador({
          id_ambassador_profile_filter: LOCAL_AMBASSADOR_ID(),
          searchByIdMeasure: currentMedition.id_measure,
        })
      }
    }
  }

  changeStatusOption = () => {
    let { exportTemplate, exportScopeSelect, exportType } = this.state
    let type = 1
    switch (exportType) {
      case "xlsx":
        if (exportScopeSelect === "all") {
          type = 1
        } else if (isNaN(parseInt(exportScopeSelect, 10))) {
          type = 2
        }
        break
      case "pdf":
        if (exportTemplate.length > 0 && exportTemplate === "table") {
          if (exportScopeSelect === "all") {
            type = 3
          } else {
            type = 4
          }
        } else if (
          exportTemplate.length > 0 &&
          exportTemplate === "presentation"
        ) {
          if (exportScopeSelect === "all") {
            type = 5
          } else {
            type = 6
          }
        }
        break
    }
    return type
  }

  validateQualitativeComments = () => {
    let { configuration } = this.props
    if (validRole({ role: [5] })) {
      if (configuration.ambassador_qualitative_results_visible === 0) {
        return false
      }
    }

    if(!this.state.currentMedition.has_qualitative_answers){
      return false
    }

    return true
  }

  validateMultiple = () => {
    const { exportMedition, exportScopeSelect  } = this.state
    if (validate.exist(exportMedition)) {
      if(exportScopeSelect == 'all' && !exportMedition.survey_segment){
        return exportMedition.include_multiple
      } else if(exportScopeSelect == 'segmento' && exportMedition.survey_segment) {
        return exportMedition.include_multiple
      } else if (exportScopeSelect == 'division' && !exportMedition.survey_segment){
        return exportMedition.include_multiple
      }
    }
    return false
  }

  pressExport = () => {
    buttonAction_btns("Generar reporte de medicion")
    let {
      exportScope,
      exportMedition,
      exportMeditionLeader,
      exportScopeSelect,
      exportType,
      defaultOptions,
      defaultSegmentOptions,
      defaultLeaderShipOptions,
      exportTemplate,
      exportDownload,
      exportSegment,
    } = this.state

    let validatePresentation = exportTemplate === "presentation"
    let typeReport = this.changeStatusOption()
    let findOptionValues = defaultOptions.find((opt) => {
      return opt.type === typeReport
    }).values
    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()
    defaultOptions = findOptionValues.map((opt) => {
      return opt.slice(0, -1)
    }) // remove the last letter of variable

    let mapOptionValues = defaultLeaderShipOptions.find((opt) => {
      return opt.type === typeReport
    })
    let findOptionValuesLeaders = []
    if (mapOptionValues) {
      findOptionValuesLeaders = mapOptionValues.values
      defaultLeaderShipOptions = findOptionValuesLeaders.map((opt) => {
        return opt.slice(0, -1)
      }) // remove the last letter of variable
    }
    let visible_seg = exportScopeSelect == "all" && medition_segment == true
    let visible_div =
      exportScopeSelect == "division" && medition_segment == true
    let validateSegment =
      defaultSegmentOptions.length > 0 &&
      defaultOptions.includes("bySegment") &&
      (exportTemplate === "presentation" ||
        exportType === "pdf" ||
        exportType === "xlsx")
    let object
    let originalInfo = {
      id_division: exportMeditionLeader
        ? false
        : exportScopeSelect != "division"
        ? false
        : exportScope,
      id_segment:
        visible_div == true
          ? false
          : exportScopeSelect != "segmento"
          ? isNaN(exportSegment)
            ? false
            : exportSegment
          : exportSegment,
      id_position: !exportMeditionLeader
        ? false
        : exportScopeSelect === "all"
        ? false
        : exportScope, // id del equipo
      measure_id: exportMedition ? exportMedition.id_measure : -1,
      type: exportType,
      leader: exportMeditionLeader,
      download_zip:
        exportScopeSelect === "all" && exportDownload.includes("division"),
      report_recipients: !validRole({ role: [5, 6] })
        ? defaultOptions.includes("byDestinatario")
        : false, //
      result_divisions: exportMeditionLeader
        ? false
        : defaultOptions.includes("byDivision"), // true
      result_dimensions: !exportMeditionLeader
        ? defaultOptions.includes("byDimension")
        : defaultLeaderShipOptions.includes("byDimension"), // true
      multiple_option: !exportMeditionLeader
        ? visible_seg == true || visible_div == true
          ? false
          : defaultOptions.includes("byMultipleOption") && this.state.currentMedition.include_multiple
        : defaultLeaderShipOptions.includes("byMultipleOption") && this.state.currentMedition.include_multiple,
      comments_qualitative: this.validateQualitativeComments()
        ? !exportMeditionLeader
          ? visible_seg == true
            ? false
            : visible_div == true
            ? false
            : defaultOptions.includes("qualitative")
          : defaultLeaderShipOptions.includes("qualitative")
        : false, // true
      result_nps: this.state.hasEnps? exportMeditionLeader
        ? defaultLeaderShipOptions.includes("byEnps")
        : defaultOptions.includes("byEnps") : false, // true
      comparative_division: exportMeditionLeader
        ? false
        : visible_seg == true
        ? false
        : visible_div == true
        ? false
        : defaultOptions.includes("division"),
      comparative_team:
        !exportMeditionLeader || validRole({ role: [6] })
          ? false
          : !exportScopeSelect === "all"
          ? false
          : isUserLeader
          ? defaultLeaderShipOptions.includes("team")
          : visible_seg == true
          ? false
          : visible_div == true
          ? false
          : defaultOptions.includes("team"), //

      comparative_demographic_variables:
        defaultOptions.includes("bySegment")
        ? visible_seg == true || visible_div == true
            ? (exportMedition?.new_version==0? false : true)
            : !!(exportType === "xlsx" && validateSegment)
        : false,
      segment: {
        show: visible_div == true && exportMedition.new_version==0  ? false : validateSegment,
        variables: {
          byAge:
            visible_div == true && exportMedition.new_version==0
              ? false
              : validateSegment && defaultSegmentOptions.includes("byAge"),
          byCompanyTime:
            visible_div == true && exportMedition.new_version==0
              ? false
              : validateSegment &&
                defaultSegmentOptions.includes("byCompanyTime"),
          byGender:
            visible_div == true && exportMedition.new_version==0
              ? false
              : validateSegment && defaultSegmentOptions.includes("byGender"),
          byCategory:
            visible_div == true && exportMedition.new_version==0
              ? false
              : validateSegment && defaultSegmentOptions.includes("byCategory"),
          byLocation:
            visible_div == true && exportMedition.new_version==0
              ? false
              : validateSegment && defaultSegmentOptions.includes("byLocation"),
        },
      },
      result_teams:
        !exportMeditionLeader || validRole({ role: [6] })
          ? false
          : defaultLeaderShipOptions.includes("byTeam"),
      result_segment: defaultOptions.includes("bySegment"),
    }

    if (!validatePresentation) {
      object = originalInfo
    } else {
      object = {
        ...originalInfo,
        presentation: {
          show: exportTemplate === "presentation",
          variables: {
            tmpIntroduction:
              validatePresentation &&
              defaultOptions.includes("tmpIntroduction"),
            tmpSummary:
              validatePresentation && defaultOptions.includes("tmpSummary"),
            tmpMeasureModel:
              validatePresentation &&
              defaultOptions.includes("tmpMeasureModel"),
            tmpMeasureMethodology:
              validatePresentation &&
              defaultOptions.includes("tmpMeasureMethodology"),
            tmpAllResult:
              validatePresentation && defaultOptions.includes("tmpAllResult"),
            tmp_nps: validatePresentation && defaultOptions.includes("byEnps"),
            tmp_dimension:
              validatePresentation && defaultOptions.includes("byDimension"),
            tmp_comparative_division:
              validatePresentation && defaultOptions.includes("division"),
            tmpSegment:
              validatePresentation && defaultOptions.includes("bySegment"),
            tmpConclusions:
              validatePresentation && defaultOptions.includes("conclusions"),
          },
        },
        segment: {
          show: validateSegment,
          variables: {
            byAge: validateSegment && defaultSegmentOptions.includes("byAge"),
            byCompanyTime:
              validateSegment &&
              defaultSegmentOptions.includes("byCompanyTime"),
            byGender:
              validateSegment && defaultSegmentOptions.includes("byGender"),
            byCategory:
              validateSegment && defaultSegmentOptions.includes("byCategory"),
            byLocation:
              validateSegment && defaultSegmentOptions.includes("byLocation"),
          },
        },
      }
    }

    const getVariables = (obj) => {
      const variablesDictionary = {
        report_recipients: "Reporte de destinatarios",
        result_dimensions: "Resultado por dimensión",
        result_nps: "Resultado por eNPS",
        result_divisions: "Resultado por división",
        comments_qualitative: "Comentarios cualitativos",
        comparative_division: "Comparativo por división",
        multiple_option: "Opción múltiple",
      }

      return Object.keys(obj)
        .map((item) => (obj[item] ? variablesDictionary[item] : null))
        .filter((item) => item)
    }

    const mapSegmentOptions = (options) => {
      const segementsDictionary = {
        byAge: "Edad",
        byCompanyTime: "Tiempo en la empresa",
        byGender: "Género",
        byCategory: "Categoría jerárquica",
        byLocation: "Ubicación geográfica",
      }

      return options.map((option) => segementsDictionary[option])
    }

    const getWoopraObject = () => {
      let obj = {}
      let type = this.state.exportMeditionLeader
        ? "liderazgo"
        : "clima y engagement"
      let name = this.state.currentMedition.name
      let exportType = this.state.exportType === "xlsx" ? "excel" : "pdf"
      let scope =
        this.state.exportScopeSelect === "all"
          ? "Organización"
          : this.state.exportMeditionLeader
          ? "Equipo"
          : "División"

      let segmentOptions = mapSegmentOptions(this.state.defaultSegmentOptions)
      let analysisBySegment = object.segment.show

      let _variables = getVariables(object)

      obj.medicion = name
      obj.formato = exportType
      obj.tipoDeMedicion = type
      obj.alcance = scope
      obj.variables = _variables

      if (analysisBySegment) {
        obj.segmentos = segmentOptions
        obj.variables = [...obj.variables, "Análisis por segmento"]
      }

      return obj
    }

    woopraTrack("Exportar reporte de medición", getWoopraObject())

    this.props.exportWatcher(object)
    if (exportType === "xlsx" || exportType === "pdf"  || validatePresentation) {
      this.setState({ modalExportSuccess: true })
    }
  }

  onChangeMedition(valueChange) {
    const { defaultOptions, defaultLeaderShipOptions } = this.state
    const { meditions_export } = this.props

    let findMedition = meditions_export.find(
      (r) => r.id_measure === valueChange
    )
    if (findMedition.include_multiple) {
      for (let i = 0; i < defaultOptions.length - 1; i++) {
        defaultOptions[i].values.push(`byMultipleOption${i + 1}`)
      }
      for (let i = 0; i < defaultLeaderShipOptions.length - 1; i++) {
        defaultLeaderShipOptions[i].values.push(`byMultipleOption${i + 1}`)
      }
    }
    let scopeSelect = "all"
    let segment = undefined
    if (findMedition.survey_segment) {
      if (findMedition.segments.length === 1) {
        scopeSelect = "segmento"
        segment = findMedition.segments[0].id_segment

      }
      this.setState({ exportType: "xlsx" })
    }
    this.setState({
      exportMeditionLeader: findMedition.id_survey_type === 2,
      exportMedition: findMedition,
      medition: valueChange,
      exportScopeSelect: scopeSelect,
      exportScope: undefined,
      exportSegment: segment,
      defaultOptions,
      defaultLeaderShipOptions,
    })
    if (validRole({ role: [5] })) {
      this.loadDivisions(valueChange)
    }
    this.props.history.push(`/reports/export/measure/${valueChange}`)
  }

  render() {
    let {
      exportScope,
      exportSegment,
      exportMedition,
      exportMeditionLeader,
      exportType,
      exportScopeSelect,
      exportTemplate,
      medition,
      currentMedition,
      defaultOptions,
      defaultSegmentOptions,
      messageHeader,
      isAmbassador,
      defaultLeaderShipOptions,
    } = this.state

    const {
      meditions_export,
      loading_meditions_export,
      divisions_ambassador,
      loading_divisions_ambassador,
    } = this.props

    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()

    const arrayMapScope = !exportMedition
      ? []
      : exportMeditionLeader
      ? exportMedition["team-leaders"]
      : isAmbassador
      ? divisions_ambassador
      : exportMedition.divisions

    const arraySegments = !exportMedition ? [] : exportMedition.segments
    const meditionSelected = meditions_export.find(
      (r) =>
        r.id_measure ===
        (medition || (currentMedition && currentMedition.id_measure))
    )
    medition_segment = currentMedition.survey_segment

    const meditions_not_leadership_segments = meditions_export.filter((medition) => {
      return medition.survey_segment == false || medition.id_survey_type != 2
    })

    const measuresWithSameSurveyType = meditions_not_leadership_segments.filter((medition) => {
      return currentMedition.id_survey_type == medition.id_survey_type
    })
    const hasFreshchat =
      typeof window.Intercom !== "undefined" &&
      window.self === window.top;
      const combinedStyle = {
        ...(hasFreshchat ? { marginRight: "88px" } : {}),
        ...(hasFreshchat ? { paddingRight: "0px" } : {}),
      }

    return (
      <Layout>
        <Helmet>
          <title>{this.intlExportable.titlePage}</title>
          <meta name="description" content="Reportes" />
        </Helmet>
        <div className="LayoutContainer" style={{ backgroundColor: "white" }}>
          {loading_meditions_export ? (
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          ) : (
            <Fragment>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className="ReportsExport">
                  <div className="ReportsExport-header-btn-back">
                    <span>
                      <button
                        className="btnBackReport"
                        onClick={() => {
                          woopraTrack("Volver a la medición")
                          if(isAmbassadorActive()){
                            this.props.history.goBack()
                          } else {
                            this.props.history.push(`/reports/measure/${currentMedition.id_survey_type}/${currentMedition.id_measure}`)
                          }
                        }}>
                        <LeftOutlined /> {messageHeader}
                      </button>
                    </span>
                  </div>
                  <div style={{ marginTop: ".5rem" }}>
                    <span className="title_section">
                      {this.intlExportable.title}
                    </span>
                  </div>
                </div>
              </div>
              <div className="ReportsExport-body">
                <div
                  className="ReportsExport-body-measure"
                  style={isUserLeader ? { width: 980 } : {}}>
                  <div style={{ paddingBottom: "20px" }}>
                    <p style={{ marginTop: 0 }}>
                      {sanitize(this.intlExportable.selectMeasure)}
                    </p>
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      placeholder={this.intlExportable.selectMeasurePlaceHolder}
                      style={{ width: 300 }}
                      value={medition || currentMedition.id_measure}
                      onChange={(valueChange) =>
                        this.onChangeMedition(valueChange)
                      }>
                      {Array.isArray(measuresWithSameSurveyType) &&
                        measuresWithSameSurveyType.map((m, i) => (
                          <Option key={i} value={m.id_measure}>
                            {m.name ? m.name : "-1"}
                          </Option>
                        ))}
                    </Select>
                  </div>
                  <p style={{ marginTop: 0 }}>
                    {sanitize(this.intlExportable.selectScope)}
                  </p>
                  <div className="ReportsExport-body-meditions">
                    <Radio.Group
                      value={exportScopeSelect}
                      onChange={(e) => {
                        if(e.target.value == 'all'){
                          this.setState({exportSegment: undefined})
                        }
                        this.setState({ exportScopeSelect: e.target.value })
                      }}>
                      {!validRole({ role: [5, 6] }) &&
                        (medition_segment == true &&
                        arraySegments.length == 1 ? (
                          <Radio
                            style={{ width: "fit-content" }}
                            value="segmento"
                            onClick={(e) => {
                              this.setState({
                                exportSegment: arraySegments[0].id_segment,
                              })
                            }}>
                            {arraySegments[0].name}
                          </Radio>
                        ) : (
                          <Radio style={{ width: "fit-content" }} value="all">
                            Toda la organización
                          </Radio>
                        ))}
                      <Radio style={{ width: "150px" }} value="division">
                        {exportMeditionLeader
                          ? isUserLeader
                            ? this.intlExportable.specificLeader
                            : this.intlExportable.specificTeam
                          : this.intlExportable.specificDivision}
                      </Radio>
                      {exportScopeSelect == "division" &&
                        !isAmbassador &&
                        !isUserLeader && (
                          <div className="ReportsExport-body-meditions-division">
                            <Select
                              showSearch
                              placeholder={
                                exportMeditionLeader
                                  ? this.intlExportable.selectTeamPlaceholder
                                  : this.intlExportable
                                      .selectDivisionPlaceHolder
                              }
                              allowClear
                              style={{ width: 200 }}
                              value={
                                exportScope && !isNaN(parseInt(exportScope, 10))
                                  ? parseInt(exportScope, 10)
                                  : undefined
                              }
                              onChange={(e) =>
                                this.setState({ exportScope: e })
                              }
                              filterOption={(input, option) =>
                                option.props.children.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }>
                              {Array.isArray(arrayMapScope) &&
                                arrayMapScope.map((f, i) => (
                                  <Option
                                    key={i}
                                    value={f.id_division || f.id_position}>
                                    <Tooltip
                                      placement="leftTop"
                                      title={
                                        f.division_name ||
                                        `${f.leader_name} ${f.leader_last_name}`
                                      }
                                      align={{
                                        offset: [-8, -6],
                                      }}>
                                      {f.division_name ||
                                        `${f.leader_name} ${f.leader_last_name}`}
                                    </Tooltip>
                                  </Option>
                                ))}
                            </Select>
                          </div>
                        )}
                      {(isAmbassador || isUserLeader) &&
                        exportScopeSelect === "division" &&
                        (loading_divisions_ambassador ? (
                          <div className="loadingSpin">
                            <Spin size="large" />
                          </div>
                        ) : (
                          <div className="ReportsExport-body-meditions-division">
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              placeholder={
                                exportMeditionLeader
                                  ? isUserLeader
                                    ? this.intlExportable.selectLeader
                                    : this.intlExportable.selectTeam
                                  : this.intlExportable
                                      .selectDivisionPlaceHolder
                              }
                              allowClear
                              style={{ width: 200 }}
                              value={
                                exportScope && !isNaN(parseInt(exportScope, 10))
                                  ? parseInt(exportScope, 10)
                                  : undefined
                              }
                              onChange={(e) =>
                                this.setState({ exportScope: e })
                              }>
                              {Array.isArray(arrayMapScope) &&
                                arrayMapScope.map((f, i) => (
                                  <Option
                                    key={i}
                                    value={f.id_division || f.id_position}>
                                    {f.division_name ||
                                      `${f.leader_name} ${f.leader_last_name}`}
                                  </Option>
                                ))}
                            </Select>
                          </div>
                        ))}
                      {medition_segment == true &&
                        arraySegments.length > 1 &&
                        !isAmbassador && (
                          <Radio value="segmento">Segmento especifico</Radio>
                        )}
                      {exportScopeSelect == "segmento" &&
                        medition_segment == true &&
                        currentMedition.segments.length > 1 &&
                        !isAmbassador &&
                        !isUserLeader && (
                          <Select
                            showSearch
                            placeholder="Seleccionar segmento"
                            allowClear
                            style={{ width: "200px" }}
                            value={
                              exportSegment &&
                              !isNaN(parseInt(exportSegment, 10))
                                ? parseInt(exportSegment, 10)
                                : undefined
                            }
                            onChange={(e) =>
                              this.setState({ exportSegment: e })
                            }
                            filterOption={(input, option) =>
                              option.props.children.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }>
                            {Array.isArray(arraySegments) &&
                              arraySegments.map((f, i) => (
                                <Option key={i} value={f.id_segment}>
                                  <Tooltip
                                    placement="leftTop"
                                    title={f.name}
                                    align={{
                                      offset: [-8, -6],
                                    }}>
                                    {f.name}
                                  </Tooltip>
                                </Option>
                              ))}
                          </Select>
                        )}
                    </Radio.Group>
                  </div>
                  <p style={{ marginTop: 0 }}>
                    {sanitize(this.intlExportable.selectFormat)}
                  </p>
                  <div className="ReportsExport-body-meditions">
                    <Radio.Group
                      value={exportType}
                      onChange={(e) => {
                        this.setState({ exportType: e.target.value }, () => {
                          if (e.target.value === "xlsx") {
                            this.setState({ exportTemplate: "table" })
                          }
                        })
                      }}>
                      <Radio value="xlsx">Excel</Radio>
                      {medition_segment == false && [1,2].includes(currentMedition.id_survey_type) && (
                        <Radio value="pdf">PDF</Radio>
                      )}
                    </Radio.Group>
                  </div>
                  {exportType === "pdf" && (
                    <Fragment>
                      <p style={{ marginTop: 0 }}>
                        {sanitize(this.intlExportable.selectPdfTemplate)}
                      </p>
                      <div className="ReportsExport-body-meditions">
                        <Radio.Group
                          value={exportTemplate}
                          onChange={(e) => {
                            this.setState({ exportTemplate: e.target.value })
                          }}>
                          <Radio value="table">
                            {this.intlExportable.table}
                          </Radio>
                          {!exportMeditionLeader && (
                            <Radio value="presentation">
                              {this.intlExportable.presentation}
                            </Radio>
                          )}
                        </Radio.Group>
                      </div>
                    </Fragment>
                  )}

                  <p style={{ marginTop: 0 }}>
                    {sanitize(this.intlExportable.selectVariables)}
                  </p>
                  <div
                    className="ReportsExport-body-variables"
                    style={isUserLeader ? { gridTemplateColumns: "auto" } : {}}>
                    {exportMedition &&
                    <VariablesExport
                    exportTemplate={exportTemplate}
                    exportMedition={exportMedition}
                    exportScopeSelect={exportScopeSelect}
                    medition_segment={medition_segment}
                    exportType={exportType}
                    options={
                      exportMeditionLeader
                        ? defaultLeaderShipOptions
                        : defaultOptions
                    }
                    hasEnps={this.state.hasEnps}
                    defaultSegmentOptions={defaultSegmentOptions}
                    exportMeditionLeader={exportMeditionLeader}
                    validateQualitativeComments={this.validateQualitativeComments()}
                    validateMultiple={this.validateMultiple()}
                    onChangeVariable={(e, type) => {
                      if (exportMeditionLeader) {
                        let newOptions = this.state.defaultLeaderShipOptions
                        newOptions[type].values = e
                        this.setState({
                          defaultLeaderShipOptions: newOptions,
                        })
                      } else {
                        let newOptions = this.state.defaultOptions
                        newOptions[type].values = e
                        this.setState({ defaultOptions: newOptions })

                      }
                    }}
                    onChangeVariableSegment={(e) =>
                      this.setState({ defaultSegmentOptions: e })
                    }
                  />}

                  </div>
                </div>
                {exportType === "pdf" && (
                  <Fragment>
                    <div className="space-white" />
                    <div className="preview-image">
                      <PreviewImage
                        measure={meditionSelected}
                        exportTemplate={exportTemplate}
                        exportScopeSelect={exportScopeSelect}
                      />
                    </div>
                  </Fragment>
                )}
              </div>

              <div className="ReportsExport-footer" style={combinedStyle}>
                {(exportScopeSelect === "division" &&
                  isNaN(parseInt(exportScope, 10))) ||
                (exportScopeSelect === "segmento" &&
                  isNaN(parseInt(exportSegment, 10))) ? (
                  <Button disabled type="primary">
                    {" "}
                    {this.intlExportable.generate}
                  </Button>
                ) : (
                  <Button type="primary" onClick={this.pressExport}>
                    {this.intlExportable.generate}
                  </Button>
                )}
              </div>
            </Fragment>
          )}
          <ModalCustom
            showOnlyAccept
            modalOpen={this.state.modalExportSuccess}
            onOk={() =>
              this.setState({
                modalExportSuccess: false,
              })
            }>
            <img src={imageMail} className="mailIcon" />
            <span style={{ fontSize: 14 }}>
              {sanitize(this.intlExportable.messageExport)}
            </span>
          </ModalCustom>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = createStructuredSelector({

  loading_meditions_export: makeSelectLoadingMeditionsReportExport(),
  meditions_export: makeSelectReportExport(),
  divisions_ambassador: makeSelectDivisionAmbassador(),
  loading_divisions_ambassador: makeSelectLoadingDivisionsReportExport(),
  configuration: makeSelectConfiguration(),
})

function mapDispatchToProps(dispatch) {
  return {
    getMeditionsExport: (params) =>
      dispatch(getMeditionsReportExportWatcher(params)),
    getDivisionsAmbasador: (params) =>
      dispatch(getDivisionsAmbassadorReportExportWatcher(params)),
    exportWatcher: (params) => dispatch(exportReportWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reportExport", reducer })
const withSaga = injectSaga({ key: "reportExport", saga })

export default compose(withReducer, withConnect, withSaga)(ReportExport)
